module.exports = __webpack_public_path__ + "static/memory_img4@2x-a9dfc6fc5130f27c64fb74f10022f96c.png";